<style scoped lang="sass">
#pool-participation
  margin-bottom: 1rem
  background: linear-gradient(to bottom, var(--light-gray), var(--light-gray) 23px, white 25px)
.picks-form
  margin: 0 var(--base-padding)
  .picks
    .pick
      display: flex
      margin-bottom: 0.5rem
      align-items: center
      .pick-number
        width: 2rem
        font-size: 1.2rem
        font-weight: 600
      > :nth-child(2)
        flex-grow: 1
  button
    img
      width: 1rem
      height: 1rem
      margin: 0 0 -0.1rem 0.3rem
.summary
  display:          flex
  justify-content:  center
  align-items:      center
  background-color: white
  padding:          0.5rem
  border-radius:    0.5rem
  margin:           0 var(--base-padding) 1rem var(--base-padding)
  box-shadow:       2px 2px 8px rgba(0,0,0,0.2)
  cursor:           pointer
  .current-standing
    font-size: 0.8rem
    font-weight: 700
    margin-right: 1rem
  .avatar
    width: 25px
    height: 25px
    border-radius: 13px
    margin-right: 1rem
  .participation-position
    font-size: 1.6rem
    font-weight: 700
  .participation-position-ordinal
    font-size: 0.8rem
    font-weight: 600
    margin-right: 1rem
  .participation-points
    font-size: 1.6rem
    font-weight: 300
  .participation-points-units
    font-size: 0.8rem
    font-weight: 600
    margin-right: 1rem
.pool-picks
  padding: 0 var(--base-padding)
  .header-column
    white-space: nowrap
    &:nth-child(1)
      flex: 0 0 1rem
    &:nth-child(2)
      flex: 0 0 1.5rem
    &:nth-child(3)
      flex: 5 !important
  .row
    cursor: pointer
    .column
      img
        width: 22px
        height: 22px
        border-radius: 11px
      &:nth-child(1)
        flex: 0 0 1rem
      &:nth-child(2)
        flex: 0 0 1.5rem
      &:nth-child(3)
        flex: 5 !important
</style>
<template>
  <div id="pool-participation">
    <div v-if="makePicks">
      <form @submit.prevent="savePicks" class="picks-form">
        <div v-if="savePickErrors.length">
          <div v-for="(error,i) in savePickErrors" :key="i">{{error}}</div>
        </div>
        <div class="picks">
          <div v-if="fieldSet">
            <div v-for="(participationPick, index) in participationPicks" class="input-group pick" :key="index">
              <span class="pick-number">{{index + 1}}</span>
              <pinhigh-select
                :options="pickOptions[index]"
                :value="newPicks[index]"
                :on-select="setPick(index)"
                v-if="fieldSet"
                ></pinhigh-select>
            </div>
          </div>
          <div v-else>
            You cannot make picks until the field is set. See the{{' '}}<router-link :to="{name: 'faq'}">FAQ</router-link>{{' '}}for more details.
          </div>
        </div>
        <button type="submit" class="button positive" :class="{saved: saved}" v-if="fieldSet">
          Save picks
          <img src="../assets/images/icon-check.svg" v-if="saved">
        </button>
      </form>
    </div>
    <div v-if="!makePicks">
      <div class="summary" @click.prevent="openMathModal(pool.participation)">
        <div class="current-standing">CURRENT<br />STANDING</div>
        <img :src="pool.participation.user.avatar_url" class="avatar">
        <div>
          <span class="participation-position">{{pool.participation.position | pinhighDisplayParticipantPosition({tie: pool.participation.tie, justNumber: true})}}</span><!--
          --><span class="participation-position-ordinal">{{pool.participation.position | pinhighDisplayParticipantPosition({tie: pool.participation.tie, justOrdinal: true})}}</span>
        </div>
        <div>
          <span class="participation-points">{{pool.participation.points}}</span><!--
          --><span class="participation-points-units">PTS</span>
        </div>
      </div>
      <pinhigh-table
          :headers="['YOUR PICKS', '', '', 'POS', 'TOT', 'RD', 'THRU']"
          :rows="participationPicks"
          class="pool-picks"
        >
        <template slot="headers" slot-scope="props">
          <div class="column header-column" v-for="(header,i) in props.headers" :key="i">{{header}}</div>
        </template>
        <template slot="row" slot-scope="props">
          <div class="row" @click.prevent="openScorecardModal(props.row)">
            <div class="column">{{props.index + 1}}</div>
            <div class="column"><img :key="props.row.image_url" :src="props.row.image_url" /></div>
            <div class="column"><div class="ellipsis-overflow"><span :key="props.row.playerId">{{props.row.playerId}}</span></div></div>
            <div class="column"><span :key="props.row.position">{{props.row.position | pinhighDisplayPlayerPosition({tie: props.row.tie, status: props.row.status, justNumber: true})}}</span></div>
            <div class="column"><span :key="props.row.score">{{props.row.net_score | pinhighDisplayTotalStrokes}}</span></div>
            <div class="column"><span :key="props.row.today">{{props.row.net_today | pinhighDisplayTotalStrokes}}</span></div>
            <div class="column"><span :key="props.row.through">{{props.row.today_through | pinhighDisplayThrough}}</span></div>
          </div>
        </template>
      </pinhigh-table>
    </div>
    <math-modal v-if="mathModal" :on-close="closeMathModal" :participation="mathModal"></math-modal>
    <scorecard-modal v-if="scorecardModal" :on-close="closeScorecardModal" :tournament-player="scorecardModal"></scorecard-modal>
  </div>
</template>
<script>
import Vue            from 'vue';
import indicator      from 'ordinal/indicator';
import moment         from 'moment';

import MathModal      from './math-modal.vue';
import ScorecardModal from './scorecard-modal.vue';
import api            from '../api';

export default {
  name: 'PoolParticipation',
  components: {
    MathModal,
    ScorecardModal
  },
  created() {
    this.newPicks = this.picksConfig.picks;
  },
  props: {
    pool: Object
  },
  data: () => {
    return {
      newPicks:       [],
      savePickErrors: [],
      saved:          false,
      mathModal:      null,
      scorecardModal: null
    }
  },
  computed: {
    makePicks() {
      return this.pool.participation && moment().isBefore(this.pool.tournament.start_time);
    },
    pickOptions() {
      let options = [];
      for (let i = 0; i < this.pool.pool_style_config.value; i++) {
        if (this.pool.pool_style_id === 'Individual Picks') {
          options.push(this.pool.pool_style_config.field.map(name => ({label: name, value: name})));
        } else {
          options.push(
            this.pool.pool_style_config.field
              .filter(({bracket}) => (bracket === (i + 1)))
              .map(({name}) => ({label: name, value: name}))
          );
        }
      }
      return options;
    },
    picksConfig() {
      return this.pool.participation.picks_config || {picks: []};
    },
    fieldSet() {
      return this.pool.pool_style_config.field && this.pool.pool_style_config.field.length;
    },
    participationPicks() {
      return Array
        .from({length: this.pool.pool_style_config.value})
        .map((v,i) => {
          const playerId = this.picksConfig.picks[i];
          const tournamentPlayer = this.pool.tournament.tournament_players.find(({player_id}) => playerId === player_id);
          return {
            playerId,
            image_url:     tournamentPlayer ? tournamentPlayer.image_url : null,
            position:      tournamentPlayer ? tournamentPlayer.position : null,
            tie:           tournamentPlayer ? tournamentPlayer.tie : null,
            net_score:     tournamentPlayer ? tournamentPlayer.net_score : null,
            net_today:     tournamentPlayer ? tournamentPlayer.net_today : null,
            today_through: tournamentPlayer ? tournamentPlayer.today_through : null,
            status:        tournamentPlayer ? tournamentPlayer.status : null,
            id:            tournamentPlayer ? tournamentPlayer.id : null
          };
        });
    }
  },
  methods: {
    setPick(index) {
      return option => {
        Vue.set(this.newPicks, index, option);
      };
    },
    savePicks() {
      api.Picks.update({params: {id: this.pool.id, picks: {picks_config: {picks: this.newPicks}}}})
        .then(() => {
          this.$store.dispatch('updateCachedPool', {params: {id: this.pool.id}});
          this.saved = true;
          this.savePickErrors = [];
        })
        .catch(({response}) => {
          this.savePickErrors = response.data.errors;
          this.saved = false;
        });
    },
    indicator(num) {
      return indicator(num).toUpperCase();
    },
    openMathModal(participation) {
      this.mathModal = participation;
    },
    closeMathModal() {
      this.mathModal = null;
    },
    openScorecardModal(tournamentPlayer) {
      this.scorecardModal = tournamentPlayer;
    },
    closeScorecardModal() {
      this.scorecardModal = null;
    }
  }
};
</script>
